import React, { useState, useEffect } from "react";
import axios from "axios";
import { Modal, Button, Form, Alert } from "react-bootstrap";

function Dashboard1Party() {
  const [show, setShow] = useState(false);
  const [formData, setFormData] = useState({
    sheet_Name: "",
    Proof1: "",
    Proof2: "",
    Proof3: "",
    Director_office: "",
    DPCO: "",
    CPT: "",
    Session: "",
    Date: "",
    Remark: "",
  });
  const [data, setData] = useState([]);
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");
  const [editId, setEditId] = useState(null);
  const [filterColumn, setFilterColumn] = useState("sheet_Name");
  const [filterText, setFilterText] = useState("");

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => setMessage(""), 3000);
      return () => clearTimeout(timer);
    }
  }, [message]);

  const fetchData = async () => {
    try {
      const response = await axios.get("https://sheetmanagement.sobalex.com/backend/public/index.php?endpoint=1party");
      if (response.data.status === "success") {
        setData(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (editId !== null) {
        const response = await axios.put(`https://sheetmanagement.sobalex.com/backend/public/index.php?endpoint=1party&id=${editId}`, formData);
        if (response.data.status === "success") {
          setMessage("Record updated successfully!");
          setMessageType("success");
        } else {
          setMessage(response.data.message);
          setMessageType("danger");
        }
      } else {
        const response = await axios.post("https://sheetmanagement.sobalex.com/backend/public/index.php?endpoint=1party", formData);
        if (response.data.status === "success") {
          setMessage("Data added successfully!");
          setMessageType("success");
        } else {
          setMessage(response.data.message);
          setMessageType("danger");
        }
      }
      setShow(false);
      fetchData();
      setFormData({
        sheet_Name: "",
        Proof1: "",
        Proof2: "",
        Proof3: "",
        Director_office: "",
        DPCO: "",
        CPT: "",
        Session: "",
        Date: "",
        Remark: "",
      });
      setEditId(null);
    } catch (error) {
      setMessage("Server error. Try again later.");
      setMessageType("danger");
    }
  };

  const handleEdit = (item) => {
    setFormData(item);
    setEditId(item.id);
    setShow(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this record?")) return;
    try {
      const response = await axios.delete(`https://sheetmanagement.sobalex.com/backend/public/index.php?endpoint=1party&id=${id}`);
      if (response.data.status === "success") {
        setMessage("Record deleted successfully!");
        setMessageType("success");
        fetchData();
      }
    } catch (error) {
      setMessage("Delete failed.");
      setMessageType("danger");
    }
  };

  const filteredData = data.filter((item) =>
    item[filterColumn]?.toLowerCase().includes(filterText.toLowerCase())
  );

  return (
    <div className="container mt-5">
      <h2>1Party Dashboard</h2>
      {message && <Alert variant={messageType}>{message}</Alert>}

      <div className="d-flex mb-3">
        <select
          className="form-select me-2"
          value={filterColumn}
          onChange={(e) => setFilterColumn(e.target.value)}
        >
          <option value="sheet_Name">Sheet Name</option>
          <option value="Proof1">1st Proof</option>
          <option value="Proof2">2nd Proof</option>
          <option value="Proof3">3rd Proof</option>
          <option value="Director_office">Director Office</option>
          <option value="DPCO">DPCO</option>
          <option value="CPT">CPT</option>
          <option value="Session">Session</option>
          <option value="Date">Date</option>
          <option value="Remark">Remark</option>
        </select>
        <input
          type="text"
          className="form-control"
          placeholder="Filter value"
          value={filterText}
          onChange={(e) => setFilterText(e.target.value)}
        />
      </div>

      <Button variant="primary" onClick={() => setShow(true)}>Add Data</Button>

      <Modal show={show} onHide={() => setShow(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>{editId ? "Edit Data" : "Add Data"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            {Object.entries(formData).map(([key, value]) => (
              <Form.Group className="mb-3" key={key}>
                <Form.Label>{key.replace(/_/g, ' ')}</Form.Label>
                <Form.Control
                  type={key === "Date" ? "date" : "text"}
                  name={key}
                  value={value}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            ))}
            <Button type="submit" variant="success" className="w-100">
              {editId ? "Update" : "Submit"}
            </Button>
          </Form>
        </Modal.Body>
      </Modal>

      <h3 className="mt-4">Stored Data</h3>
      <table className="table table-bordered">
        <thead>
          <tr>
            <th>Sheet Name</th>
            <th>1st Proof</th>
            <th>2nd Proof</th>
            <th>3rd Proof</th>
            <th>Director Office</th>
            <th>DPCO</th>
            <th>CPT</th>
            <th>Session</th>
            <th>Date</th>
            <th>Remark</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {filteredData.length > 0 ? (
            filteredData.map((row) => (
              <tr key={row.id}>
                <td>{row.sheet_Name}</td>
                <td>{row.Proof1}</td>
                <td>{row.Proof2}</td>
                <td>{row.Proof3}</td>
                <td>{row.Director_office}</td>
                <td>{row.DPCO}</td>
                <td>{row.CPT}</td>
                <td>{row.Session}</td>
                <td>{row.Date}</td>
                <td>{row.Remark}</td>
                <td>
                  <Button variant="warning" size="sm" onClick={() => handleEdit(row)} className="me-2">Edit</Button>
                  <Button variant="danger" size="sm" onClick={() => handleDelete(row.id)}>Delete</Button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="11" className="text-center">No data available</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default Dashboard1Party;
